import { Container } from "@mui/material";
import { type FC, type ReactNode } from "react";

import { InsightsNav } from "~/feature/insights/components/InsightsNav";
import { InsightsSidebarLayout } from "~/feature/insights/components/InsightsSidebar";
import {
  type IInsightCategory,
  type IInsightsSidebarData,
} from "~/feature/insights/types";

import * as Styled from "../../pages/InsightsPage/InsightsPage.styles";

interface IInsightsPageShellProps {
  categories: IInsightCategory[];
  sidebar?: IInsightsSidebarData;
  header?: ReactNode;
  children: ReactNode;
}

export const InsightsPageShell: FC<IInsightsPageShellProps> = ({
  categories,
  sidebar,
  header,
  children,
}) => (
  <>
    <Container maxWidth="xl">
      {categories.length > 0 && <InsightsNav categories={categories} />}
    </Container>
    <Container maxWidth="lg">
      <Styled.Root>
        {header}
        {sidebar ? (
          <InsightsSidebarLayout sidebar={sidebar}>{children}</InsightsSidebarLayout>
        ) : (
          children
        )}
      </Styled.Root>
    </Container>
  </>
);
